import MiFile from './MiFile.vue'

export default MiFile
